module.exports = [
  require('./list/ancient_deep_crow'),
  require('./list/chaos_quadrapod'),
  require('./list/clockwork_dragon'),
  require('./list/deep_crow'),
  require('./list/keg_robot'),
]
